<template>
  <div id="navse" class="navbar-wrapper"
    v-bind:class="{ 'landing': isLanding, 'affix': isAffix }"
    data-aos="fade-in" data-aos-once="true">
    <div-container column-num="is-11" style="padding-top:30px;">
      <div class="columns is-gapless is-mobile navbar-full">

        <div class="column is-narrow column-link navbar-brand" align="left">
          <router-link href="/"  :to="{ name: 'landing' }">
            <img src="../assets/logo.svg" width="110" class="img-responsive"
              :style="{ maxHeight: 'auto' }" />
            <!-- <span data-aos="fade-up" data-aos-once="true">noctorus</span> -->
          </router-link>
        </div>

        <div class="column navbar-brand is-hidden-touch has-text-centered">
          <router-link href="/"  :to="{ name: 'landing' }">
            <span data-aos="fade-up" data-aos-once="true" style="margin-left:110px;">noctorus</span>
          </router-link>
        </div>

        <div class="column is-hidden-desktop">
        </div>

        <div v-for="navItem in navMain" class="column column-link is-narrow is-hidden-touch"
          :class="{ 'is-active': $route.name === navItem.name }" style="display:none;">
          <router-link :class="{ active: $route.name === navItem.name }" :href="navItem.path" :to="{ name: navItem.name, params: navItem.params }">
            {{ navItem.title }}
          </router-link>
        </div>

        <dropdown v-for="navItem in navMain" :key="navItem.name" :visible="visible"
          class="column column-link is-narrow is-hidden-touch has-text-right"
          :animation="'ani-slide-y'"
          :position="['center', 'bottom', 'center', 'top']"
          @positioned="onDropdownPosition($event)">
          <a v-if="navItem.subnav" :href="[navItem.section ? '/?anchor=' + navItem.section : (navItem.path ? navItem.path : '#')]"
            :class="{ 'nav-item-link': true, active : $route.name === navItem.name }"
            @click="[ navItem.section ? onScrollTo($event, 'landing', navItem.section) : (navItem.path ? '' : $event.preventDefault())]"
            @mouseover="onMouseOverSubnav($event, navItem.subnav)"
            @mouseout="onMouseOutSubnav($event, navItem.subnav)" style="display:block;">
            <span class="link">
              {{ navItem.title }}
            </span>
            <span v-if="navItem.subnav">
              &nbsp;<i class="fa fa-caret-right" style="vertical-align:middle;font-size:1.2em;"></i>
            </span>
          </a>
          <router-link v-else :class="{ 'nav-item-link': true, active: $route.name === navItem.name }" :href="navItem.path" :to="{ name: navItem.name, params: navItem.params }">
            {{ navItem.title }}
          </router-link>

          <div v-if="navItem.subnav" slot="dropdown" class="dropdown-wrapper" @mouseover="visible = true" @mouseout="visible = false">
            <div v-for="navSubItem in navItem.subnav" class="dropdown-item has-text-left">
              <a v-if="navSubItem.section" :href="[navSubItem.section ? '/?anchor=' + navSubItem.section : (navSubItem.path ? navSubItem.path : '#')]" @click="[ navSubItem.section ? onScrollTo($event, 'landing', navSubItem.section) : (navSubItem.path ? '' : $event.preventDefault())]" :class="{ 'nav-item-link': true, active : $route.name === navSubItem.name }">
                <div class="dropdown-item-inner">
                  {{ navSubItem.title }}
                </div>
              </a>
              <router-link v-else :class="{ 'nav-item-link': true, active: $route.name === navSubItem.name }" :href="navSubItem.path" :to="{ name: navSubItem.name }">
                <div class="dropdown-item-inner">
                  {{ navSubItem.title }}
                </div>
              </router-link>
            </div>
          </div>
        </dropdown>

        <div class="column is-narrow navbar-menu" @click="onToggle()" data-aos="zoom-in" data-aos-once="true">
          <div class="control-menu" :class="{ active : showNav }">
            <span></span>
          </div>
        </div>

      </div>

    </div-container>
  </div>
</template>

<script>
  import EventBus from '@/controllers/EventBus'
  import DivContainer from '@/components/DivContainer'
  import Dropdown from 'vue-my-dropdown'
  export default {
    name: 'navbarfull',
    components: {
      DivContainer,
      Dropdown
    },
    props: ['toggle'],
    data () {
      return {
        isDesktop: true,
        showNav: false,
        isLanding: false,
        isAffix: false,
        scrollOffset: 500,
        scrollPos: 0, // for vue2-scrollspy
        navMain: EventBus._data._navMain,
        visible: false
      }
    },
    computed: {
    },
    watch: {
      toggle: function (val) {
        this.showNav = val
      },
      '$route.name': function (val) {
        // in case route change, revert value to 0
        // this.isLanding = false
        // this.isAffix = false
        this.scrollPos = 0
      }
    },
    beforeCreate () {
      // in this function
      // modification to data will not invoke
    },
    created () {
      // initial init for landing and affix (mobile/desktop)
      this.isLanding = (window.innerWidth >= 1008 && this.$route.name === 'landing')
      this.isAffix = (document.body.scrollTop > this.scrollOffset ||
            document.documentElement.scrollTop > this.scrollOffset)

      // on event change hook
      this.$router.afterHooks.push((to, from) => {
        // console.log('route change get!!')
        if (to && to.name) {
          this.isLanding = (to.name === 'landing')
        }
      })

      // on event resize
      window.addEventListener('resize', function (event) {
        // console.log('on viewport change')
        this.isLanding = (event.target.innerWidth >= 1008 && this.$route.name === 'landing')
      }.bind(this))

      window.addEventListener('scroll', function (event) {
        // console.log('on scroll')
        // console.log(event)
        this.isAffix = (document.body.scrollTop > this.scrollOffset ||
              document.documentElement.scrollTop > this.scrollOffset)
      }.bind(this))
    },
    beforeMount () {
    },
    mounted () {
      // on event resize
      this.isDesktop = EventBus._isDesktop
      EventBus.$on('isDesktopChanged', function () {
        this.isDesktop = EventBus._isDesktop
      }.bind(this))

      // EventBus.$on('scroll-pos-change', (data) => {
      //   if (data &&
      //     data.name &&
      //     data.name === 'landing') {
      //     if (data.scrollPos === 0) {
      //       this.scrollPos = 0
      //     } else if (data.scrollPos >= 1 && data.scrollPos < 3) {
      //       this.scrollPos = 1
      //     } else {
      //       this.scrollPos = 2
      //     }
      //   }
      // })
    },
    methods: {
      onMouseOverSubnav ($event, subnav) {
        if (subnav) {
          this.visible = true
        }
      },
      onMouseOutSubnav ($event, subnav) {
        if (subnav) {
          this.visible = false
        }
      },
      onDropdownPosition ($event) {
        console.log('onDropdownPosition')
        console.log($event)
        this.dropdownPosition = $event
        $event.top = '90px !important'
      },
      onScrollTo (name, target) {
        if (this.$route.name !== name) {
          this.$router.replace({ name: name, query: { anchor: target } })
        } else {
          this.$scrollTo('#' + target)
        }
      },
      onToggle: function () {
        this.showNav = !this.showNav
        var className = 'modal-open'
        var root = document.documentElement
        root.className = ''
        if (this.showNav) {
          root.className += className
        } else {
          root.className -= className
        }
        this.$emit('onToggle', this.showNav)
      }
    }
  }
</script>

<style lang="scss">
@import "../styles/app_setting.scss";

html.modal-open {
  .navbar-wrapper {
    background-color: transparent;
  }
}

#navse {
  z-index: 20;
  opacity: 1;
  transition: all 0.5s ease;
  pointer-events: none;
  padding-left: 0.75rem;
  padding-right: 0.75rem;
  box-shadow: 0 0 0 0 rgba(0,0,0,.15);
  @media screen and (min-width: $desktop) {
  	pointer-events: auto;
  }

  &.landing {
    background-color: transparent;
    position: inherit;
    top: 0;
    left: 0;
    right: 0;
    z-index: 101;
  }

  // // affix mechanism to stick to top like bootstrap navbar
  // // combining with javascript
  // &.landing.affix, &.affix {
  //   width: 100%;
  //   height: 80px;
  //   background-color: $color-main;
  //   position: fixed;
  //   box-shadow: 0 2px 2px -2px rgba(0,0,0,.15);
  //
  //   img {
  //     display: inherit;
  //   }
  //
  //   .navbar-full {
  //     height: inherit;
  //   }
  // }
}

.navbar-full {
  height: 120px;
  align-items: center;
  text-align: center;
  pointer-events: none;

  @media screen and (min-width: $desktop) {
  	pointer-events: auto;
  }

  .column {
    &.navbar-brand {
      a {
        font-family: $font-family;
        font-weight: 700;
        font-size: 2.0em;
        letter-spacing: 0.06em;
        // font-weight: bold;
        color: $color-black-alt;
        transition: opacity 0.5s ease;
        img {
          vertical-align: middle;
          width: 60px;
          margin-top: -10px;
          @media screen and (min-width: $desktop) {
            width: 110px;
          }
        }
        span {
          margin-top: 80px;
          margin-left: 10px;
          color: $color-black-alt;
          transition: all 0.2s ease-in-out 0s;
          &:hover {
            color: $color-gray;
          }
        }
      }
    }
  }

  @at-root .landing.affix #{&} {

    .column {
      &.navbar-brand {
        a {
          img {
            width: 50px;
          }
        }
      }
    }
  }

  .column {
    &.column-link {
      // position: relative; do not put relative here, dropdown complication

      // abnormal fix on resizing back and forth
      html.modal-open &:before {
        background-color: transparent;
      }

      &:hover, &.is-active, &.active {
        a {
          color: $color-black-alt;
        }
      }

      .nav-item-link {
        &.active {
          color: $color-black-alt;
        }
      }

      a {
        transition: all 0.2s ease-in-out 0s;
        color: $color-gray;
        padding: 10px;

        @media screen and (min-width: $desktop) {
          padding: 15px;
        }
      }

      .dropdown-wrapper {
        background: #ccc;
        border: 1px solid #ccc;
        z-index: 8 !important;
        margin-left: 80px;
        padding-top: 5px;
        padding-bottom: 5px;

        .dropdown-item {
          padding: 0;

          .nav-item-link {
            margin: 0;
            padding: 0;
            color: $color-gray;

            &:hover, &.active {
              color: $color-black-alt;
            }

            .dropdown-item-inner {
              padding: 10px 30px;
            }
          }
        }
      }
    }

    &.navbar-brand,
    &.navbar-menu {
      padding: 15px;
      margin: 0px;
    }

    &.navbar-menu {
      @media screen and (min-width: $desktop) {
        margin-left: 20px;
      }
    }
  }

  .columns {
    height: 100%;
  }
}

.navbar-menu {
  height: 100%;
  margin: 0px;
  padding: 0px;
  margin-top: 5px;
  pointer-events: auto;
  box-shadow: 0 0 0;

  @media screen and (min-width: $desktop) {
    display: none;
  }

  // abnormal fix on resizing back and forth
  html.modal-open & {

    @media screen and (min-width: $desktop) {
      display: inherit;
    }
  }

  // cursor: pointer;
  // pointer-events: none;
  // @media screen and (min-width: $desktop) {
  // 	pointer-events: auto;
  // }

  & .control-menu {
    cursor: pointer;
    padding: 8px 25px 16px 0px;
    // left: calc(50% - 12px);
    position: absolute;
    top: 50px;
    right: 0px;

    & span {

      &, &:before, &:after {
        height: 1px;
        display: block;
        border-radius: 1px;
        background: $color-white;
        // border-bottom: 1px solid $color-black;
        position: absolute;
        // top: 45%;
        // right: 15px;
        width: 25px;
        display: block;
        content: '';
        transition: all 200ms ease-in-out;

        @media screen and (min-width: $desktop) {
          height: 2px;
          width: 30px;
          top: 50%;
        }
      }

      &:before, &:after {
        right: 0px;
        width: 20px;

        @media screen and (min-width: $desktop) {
          width: 25px;
        }
      }

      &:before {
        top: -6px;

        @media screen and (min-width: $desktop) {
          top: -8px;
        }
      }

      &:after {
        top: 6px;

        @media screen and (min-width: $desktop) {
          top: 8px;
        }
      }
    }
  }

  & .active span {
    background-color: transparent;

    &:before, &:after {
      background-color: $color-black;
      top: 0;
    }

    &:before {
      transform: rotate(45deg);
    }

    &:after {
      transform: rotate(-45deg);
    }
  }
}

</style>



// WEBPACK FOOTER //
// NavBarFull.vue?495afa88